import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { branchCustomerproductTypeList } from 'global/Models/branchCustomerProductTypeModel';
import { orderReservedByLocker, orderServices } from 'global/Models/lockerModel';
import { branchesWorkingTime, deliveryType, orderFinancialStatus, orderStatus, parcelStatus, parcelType, paymentType, pickupType, service } from 'global/Models/omOrderModel';
import { productTypeList } from 'global/Models/productTypeModel';

type initialState = {
  paymentTypes: paymentType[] | undefined;
  pickupTypes: pickupType[] | undefined;
  deliveryTypes: deliveryType[] | undefined;
  branchesWorkingTime: branchesWorkingTime[] | undefined;
  service: service[] | undefined;
  orderStatus: orderStatus[] | undefined;
  pacelCancellationType: any;
  parcelType: parcelType[] | undefined;
  parcelStatus: parcelStatus[] | undefined;
  orderFinancialStatus: orderFinancialStatus[] | undefined;
  omParcelStatus: parcelStatus[] | undefined;
  omOrderStatus: orderStatus[] | undefined;
  omOrderReservedByLocker: orderReservedByLocker | undefined;
  orderServices: orderServices[] | undefined;
  customerProductTypes: productTypeList[] | undefined;
  branchCustomerProductType: branchCustomerproductTypeList[] | undefined;
};

const initialState: initialState = {
  paymentTypes: undefined,
  pickupTypes: undefined,
  deliveryTypes: undefined,
  branchesWorkingTime: undefined,
  service: undefined,
  orderStatus: undefined,
  pacelCancellationType: undefined,
  parcelType: undefined,
  parcelStatus: undefined,
  orderFinancialStatus: undefined,
  omParcelStatus: undefined,
  omOrderStatus: undefined,
  omOrderReservedByLocker: undefined,
  orderServices: undefined,
  customerProductTypes: undefined,
  branchCustomerProductType: undefined,
};

export const parcelOrderSlice = createSlice({
  name: 'parcelOrder',
  initialState,
  reducers: {
    setOrderPaymentTypes: (state, { payload }: PayloadAction<paymentType[]>) => {
      state.paymentTypes = payload;
    },
    setOrderPickupTypes: (state, { payload }: PayloadAction<pickupType[]>) => {
      state.pickupTypes = payload;
    },
    setOrderDeliveryTypes: (state, { payload }: PayloadAction<deliveryType[]>) => {
      state.deliveryTypes = payload;
    },
    setOrderBranchesWorkingTime: (state, { payload }: PayloadAction<branchesWorkingTime[]>) => {
      state.branchesWorkingTime = payload;
    },
    setOrderService: (state, { payload }: PayloadAction<service[]>) => {
      state.service = payload;
    },
    setOrderStatus: (state, action) => {
      state.orderStatus = action.payload;
    },
    setParcelCancellationType: (state, { payload }) => {
      state.pacelCancellationType = payload;
    },
    setParcelStatus: (state, action) => {
      state.parcelStatus = action.payload;
    },
    setParcelType: (state, action) => {
      state.parcelType = action.payload;
    },
    setOrderFinancialStatus: (state, action) => {
      state.orderFinancialStatus = action.payload;
    },
    setOmParcelStatus: (state, action) => {
      state.omParcelStatus = action.payload;
    },
    setOmOrderStatus: (state, action) => {
      state.omOrderStatus = action.payload;
    },
    setOmOrderReservedByLocker: (state, { payload }: PayloadAction<orderReservedByLocker | undefined>) => {
      state.omOrderReservedByLocker = payload;
    },
    setOrderServices: (state, action) => {
      state.orderServices = action.payload;
    },
    setCustomerProductTypes: (state, action) => {
      state.customerProductTypes = action.payload;
    },
    setBranchCustomerProductTypes: (state, action) => {
      state.branchCustomerProductType = action.payload;
    },
  },
});

export const {
  setOrderPaymentTypes,
  setOrderDeliveryTypes,
  setParcelCancellationType,
  setOrderPickupTypes,
  setOrderBranchesWorkingTime,
  setOrderService,
  setOrderStatus,
  setParcelStatus,
  setParcelType,
  setOrderFinancialStatus,
  setOmParcelStatus,
  setCustomerProductTypes,
  setOmOrderStatus,
  setOmOrderReservedByLocker,
  setOrderServices,
  setBranchCustomerProductTypes,
} = parcelOrderSlice.actions;

export default parcelOrderSlice.reducer;
